import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  DvDynamicFormElement,
  DvDynamicFormModule,
  DvFormUtils,
  FormOf,
} from '@devinco/ui/legacy';
import { DataFilterAction } from '@shared/constants/data-filter-action';
import { FilterWithSelectionCrudDialogElementsService } from './filter-with-selection-crud-dialog-elements.service';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '@shared/pipes/pipes.module';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';
import {
  FilterWithSelectionCrudDialogData,
  FilterWithSelectionCrudDialogForm,
} from './interfaces';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { take } from 'rxjs';

@Component({
  imports: [
    DvDynamicFormModule,
    PipesModule,
    DvDialogContentComponent,
    DvButtonComponent,
    TranslateModule,
  ],
  selector: 'app-filter-with-selection-crud-dialog',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './filter-with-selection-crud-dialog.component.html',
})
export class FilterWithSelectionCrudDialogComponent
  extends DvDialogContent<
    FilterWithSelectionCrudDialogData,
    FilterWithSelectionCrudDialogComponent
  >
  implements OnInit
{
  private dialogElementsService = inject(
    FilterWithSelectionCrudDialogElementsService
  );
  private rolesAndPermissionsService = inject(UserRolesAndPermissionsService);

  formGroup: FormGroup<FormOf<FilterWithSelectionCrudDialogForm | undefined>>;
  elements: DvDynamicFormElement[];
  dataFilterAction: typeof DataFilterAction = DataFilterAction;

  ngOnInit(): void {
    this.rolesAndPermissionsService
      .hasPermissions([RolesAndPermissions.FilterEditExtended])
      .pipe(take(1))
      .subscribe(hasPermission => {
        this.elements = this.dialogElementsService.getFormElements();
        this.setupForm(hasPermission);
      });
  }

  performSave(): void {
    this.dialogRef.onClose(this.formGroup.value, 'confirm');
  }

  cancel(): void {
    this.dialogRef.onClose(undefined, 'close');
  }

  private setupForm(hasEditFilterExtendedPermission: boolean): void {
    this.formGroup = DvFormUtils.createFormGroup(this.elements, true);
    this.setFormValues();
    if (!hasEditFilterExtendedPermission) {
      this.formGroup.controls?.VisibleToAllUsers.disable();
    }
  }

  private setFormValues(): void {
    if (this.data.dataFilterAction === DataFilterAction.Update) {
      this.formGroup.patchValue(this.data.extraData);
    }
  }
}
